import usePostScanQrApprove from 'entity/event/usePostScanQrApprove'
import Style from '../../../StoreInfo/style'
import {
	canJoinEvent,
	getTicketInfo,
	isStaringSoon,
	isUsedTicket,
} from 'shared/utils/eventUtils'
import usePostScanQrEliminate from 'entity/event/usePostScanQrEliminate'
import usePostParticipantAddOn from 'entity/event/usePostParticipantAddOn'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import {useState} from 'react'
import {END, PAUSE, TAKING} from 'shared/constant/lookup/eventState'

const ActionButton = ({
	data,
	can_reenter,
	can_eliminate,
	can_addon,
	count,
	max_reentry,
	refetch,
	user_idx,
	required_tickets,
	clearAndRescan,
	isTournament = false,
}) => {
	const [debugClickCount, setDebugClickCount] = useState(0)
	const isUsed = isUsedTicket(data)
	const {total_player} = data?.event_timer || {}
	const reEntryCount = count && count > 0 ? count - 1 : 0
	const {serial_number} = data?.ticket_info || {}
	const {event_idx, has_joined, event_state} = data || {}
	const [, setConfirm] = useConfirmModalAtom()
	const [postScanQrApprove, isPostScanQrApproveLoading] =
		usePostScanQrApprove(refetch)
	const [postScanQrEliminate, isPostScanQrEliminateLoading] =
		usePostScanQrEliminate(() => {
			if (isTournament && isUsed) {
				clearAndRescan()
			} else {
				refetch()
			}
		})
	const [postAddOn, isPostAddOnLoading] = usePostParticipantAddOn(
		false,
		refetch
	)

	const maxEntry = data?.max_entry

	const canJoin = canJoinEvent(data)
	const isStartingSoon = isStaringSoon(data)
	const {isEnoughReEntry, isEnoughVouchers} = getTicketInfo(data)

	const isRenentryLimit =
		reEntryCount && max_reentry && reEntryCount >= max_reentry

	const isEntryLimit = maxEntry !== null && total_player >= maxEntry

	// Starting Soon
	if (isStartingSoon) {
		return (
			<div>
				<Style.SubText>⏰ 대회가 곧 시작됩니다—기대해 주세요!</Style.SubText>
				<Style.ButtonsContainer>
					<Style.ActionButton disabled>
						<Style.ButtonText>참여하기</Style.ButtonText>
					</Style.ActionButton>
				</Style.ButtonsContainer>
			</div>
		)
	}

	// Event ended
	if (event_state === END) {
		return <Style.NoteText>⛔🏁 대회가 종료되었습니다!</Style.NoteText>
	}

	// Can Join
	if (canJoin) {
		return (
			<Style.ButtonsContainer>
				<Style.ActionButton
					onClick={() => {
						setConfirm(
							`${data?.event_name} 대회에 이 선수를 등록하려고 합니다.  
이 작업을 수행하면 선수의 계정에서 ${required_tickets} 매장 이용권가 차감됩니다.`,
							() => () => postScanQrApprove(user_idx, event_idx, serial_number),
							true,
							'선수 등록 확인'
						)
					}}
					disabled={isPostScanQrApproveLoading || !isEnoughVouchers}
				>
					<Style.ButtonText>참여</Style.ButtonText>
				</Style.ActionButton>
			</Style.ButtonsContainer>
		)
	}

	// Can Eliminate
	if (can_eliminate) {
		return (
			<Style.ContentContainer>
				{isTournament && !isUsed && (
					<Style.NoteText>
						‼️️ 이 플레이어는 현재 게임에 참여 중입니다. 다시 참가하려면 먼저
						게임에서 제거해야 합니다.
					</Style.NoteText>
				)}
				<Style.ButtonsContainer>
					<Style.ActionButton
						disabled={!can_eliminate || isPostScanQrEliminateLoading}
						onClick={() => {
							setConfirm(
								`선수가 이벤트에서 제거됩니다. 진행하시겠습니까?`,
								() => () =>
									postScanQrEliminate(user_idx, event_idx, serial_number),
								true,
								'선수 탈락 확인'
							)
						}}
					>
						<Style.ButtonText>탈락</Style.ButtonText>
					</Style.ActionButton>
					{!isTournament && (
						<Style.ActionButton
							disabled={!can_addon || isPostAddOnLoading}
							onClick={() => {
								setConfirm(
									`이 선수에게 칩을 더 추가하시겠습니까?`,
									() => () => postAddOn(user_idx, event_idx),
									true,
									'추가 확인'
								)
							}}
						>
							<Style.ButtonText>
								에드온 + {`(${can_addon ? 0 : 1}/1)`}
							</Style.ButtonText>
						</Style.ActionButton>
					)}
				</Style.ButtonsContainer>
			</Style.ContentContainer>
		)
	}

	// Can Reenter store event
	if (can_reenter && !isTournament) {
		return (
			<Style.ButtonsContainer>
				<Style.ActionButton
					onClick={() => {
						setConfirm(
							`재입장을 하면 계정에서 ${required_tickets} 매장 이용권가 다시 차감됩니다. 계속하시겠습니까?`,
							() => () => postScanQrApprove(user_idx, event_idx, serial_number),
							true,
							'재입장 확인'
						)
					}}
					disabled={
						isPostScanQrApproveLoading || !isEnoughReEntry || !isEnoughVouchers
					}
				>
					<Style.ButtonText>
						재참여 ({reEntryCount}/{max_reentry || '-'})
					</Style.ButtonText>
				</Style.ActionButton>
			</Style.ButtonsContainer>
		)
	}

	// Can Reenter tournament event
	if (
		isTournament &&
		!isUsed &&
		has_joined &&
		(event_state === TAKING || event_state === PAUSE) &&
		!isRenentryLimit &&
		!isEntryLimit
	) {
		return (
			<Style.ButtonsContainer>
				<Style.ActionButton
					onClick={() => {
						setConfirm(
							`재입장을 하면 계정에서 ${required_tickets} 매장 이용권가 다시 차감됩니다. 계속하시겠습니까?`,
							() => () => postScanQrApprove(user_idx, event_idx, serial_number),
							true,
							'재입장 확인'
						)
					}}
					disabled={isPostScanQrApproveLoading || !isEnoughReEntry}
				>
					<Style.ButtonText>
						재참여 ({reEntryCount}/{max_reentry || '-'})
					</Style.ButtonText>
				</Style.ActionButton>
			</Style.ButtonsContainer>
		)
	}

	// Tournament Used Ticket
	if (isTournament && isUsed) {
		return <Style.NoteText>🎫 이 티켓은 이미 사용되었습니다</Style.NoteText>
	}

	// Tournament re-entry limit
	if (isTournament && isRenentryLimit) {
		return (
			<Style.NoteText>
				⛔ 최대 재입장 횟수에 도달했습니다. 참가할 수 없습니다.
			</Style.NoteText>
		)
	}

	return (
		<>
			<MaxEntryLimit
				isTournament={isTournament}
				maxEntry={maxEntry}
				total_player={total_player}
			/>

			<Style.ButtonsContainer>
				<Style.ActionButton
					style={{
						backgroundColor: '#B2B2B2',
						transform: 'none',
					}}
					onClick={() => {
						if (debugClickCount >= 55) {
							setDebugClickCount(0)
						} else {
							setDebugClickCount(debugClickCount + 1)
						}
					}}
				>
					{debugClickCount >= 50 ? (
						<DebugBox data={data} />
					) : (
						<Style.ButtonText>
							{has_joined
								? `재참여 (${reEntryCount}/${max_reentry || '-'})`
								: '참여'}
						</Style.ButtonText>
					)}
				</Style.ActionButton>
			</Style.ButtonsContainer>
		</>
	)
}

export default ActionButton

const MaxEntryLimit = ({isTournament, maxEntry, total_player}) => {
	if (!isTournament) return null

	if (maxEntry !== null && total_player >= maxEntry) {
		return (
			<Style.NoteText>
				⛔ 최대 참가 횟수에 도달했습니다. 참가할 수 없습니다.
			</Style.NoteText>
		)
	}

	return null
}

const DebugBox = (eventData) => {
	const {data} = eventData || {}

	return (
		<>
			<Style.ButtonText>
				has_joined :{data?.has_joined ? 'true' : 'false'}
			</Style.ButtonText>
			<Style.ButtonText>
				user_can_join :{data?.user_can_join ? 'true' : 'false'}
			</Style.ButtonText>
			<Style.ButtonText>
				can_addon :{data?.can_addon ? 'true' : 'false'}
			</Style.ButtonText>
			<Style.ButtonText>
				can_eliminate :{data?.can_eliminate ? 'true' : 'false'}
			</Style.ButtonText>
			<Style.ButtonText>
				can_reenter :{data?.can_reenter ? 'true' : 'false'}
			</Style.ButtonText>
		</>
	)
}
